import React, { useState } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined, SmileOutlined } from '@ant-design/icons';
import { Menu, Layout } from 'antd';
import DynamicCarousel from './components/DynamicCarousel'; // Import the updated component
import "./App.css";

const { Header, Sider, Content } = Layout;

const items = [
    {
        key: '1',
        label: 'History of React',
    },
    {
        key: '2',
        label: 'Glossary of Related Terms',
    },
    {
        key: '3',
        label: 'REACT in different domains',
    },
    {
        key: '4',
        label: 'React Framework Glossary',
    },
    {
        key: '5',
        label: 'Human Reactions In Culture',
    },
];

// const menuContent = {
//     '1': {
//         title: 'History of React',
//         content: [
//             'The word "react" comes from the Latin "reactus," meaning to act back or respond.',
//             'It has been used in English since the 17th century, primarily in scientific contexts.',
//             'In modern usage, it describes responses in emotional, physical, or chemical terms.',
//         ],
//         src: ['https://assets.aws.labs.envato.com/image-gen/user/07c7c2c1-c8ee-4ee2-aa90-4bb066570cf6/565443dd-3abe-4e37-a238-80e5658fb15d/7ce1cd96-d226-46e2-a122-f0b1f11f615a'],
//     },
//     '2': {
//         title: 'Glossary of Related Terms',
//         content: ['Reaction', 'Response', 'Stimulus', 'Interaction', 'Reflex'],
//         src: 'https://example.com/glossary-image.jpg',
//     },
//     '3': {
//         title: 'Simulations and Animations',
//         content: [
//             'Simulated chemical reactions using visualizations.',
//             'Animations depicting human emotional reactions, e.g., surprise or joy.',
//             'Physics-based interactions, like colliding objects.',
//         ],
//         src: [ 'https://example.com/simulations-image.jpg'],
//     },
//     '4': {
//         title: 'Useful Links for React',
//         content: [
//             'https://reactjs.org (Official React Documentation)',
//             'https://github.com/facebook/react (React Repository)',
//             'https://reactpatterns.com (Best Practices for React)',
//         ],
//         src: ['https://example.com/useful-links-image.jpg'],
//     },
//     '5': {
//         title: 'Human Reactions in Art & Literature',
//         content: [
//             'The dramatic reaction of Othello in Shakespeare’s play.',
//             'Emotional expressions in Expressionist art, such as Edvard Munch’s *The Scream*.',
//             'Cinematic examples like the iconic reaction of Darth Vader yelling "Nooo!"',
//         ],
//         src: ['https://example.com/human-reactions-image.jpg'],
//     },
// };

const menuContent = {
    '1': {
        title: 'History of React',
        content: [
            {
                textToDisplay: 'The word "react" comes from the Latin "reactus," meaning to act back or respond.',
                imageSrc: '/images/dictionary_page.jpg',
            },
            {
                textToDisplay: 'It has been used in English since the 17th century, primarily in scientific contexts.',
                imageSrc: '/images/cartoon_explaining.jpg',
            },
            {
                textToDisplay: 'In modern usage, it describes responses in emotional, physical, or chemical terms.',
                imageSrc: '/images/reactions.png',
            },
        ],
    },
    '2': {
        title: 'Glossary of Related Terms',
        content: [
            {
                textToDisplay: 'Stimulus',
                imageSrc: 'https://example.com/glossary-image3.jpg',
            },
            {
                textToDisplay: 'Reflex',
                imageSrc: 'https://example.com/glossary-image3.jpg',
            },
            {
                textToDisplay: 'Reaction',
                imageSrc: 'https://example.com/glossary-image1.jpg',
            },
            {
                textToDisplay: 'Response',
                imageSrc: 'https://example.com/glossary-image2.jpg',
            },
            {
                textToDisplay: 'Adaptation',
                imageSrc: 'https://example.com/glossary-image3.jpg',
            }

        ],
    },
    "3": {
        title: 'To REACT in different domains',
        
        content: [
        {
            textToDisplay: '1. React in usual language (the verb TO REACT): \n' +
                '\n' +
                '- Responding to an action or stimulus: Refers to how a person or object reacts to a change in the environment, an action, or an external influence.  \n' +
                '- Responding emotionally: Often used to describe a person\'s emotional reaction to a situation (e.g., "He reacted angrily when he heard the news").',
            imageSrc: '/images/angryReaction.gif',
        },
        {
            textToDisplay: '2. In chemistry: \n' +
                '- Participating in a chemical reaction: "To react" refers to how chemical substances interact with each other to form other substances. For example, oxygen and hydrogen react to form water.',
            imageSrc: '/images/h2oReaction.gif',
        },
        {
            textToDisplay: '3. In biology and medicine: \n' +
                '- The body\'s reaction: Describes how the human body or another biological organism responds to a substance, disease, medication, etc. For example, the immune system\'s reaction to an allergen or a vaccine.',
            imageSrc: '/images/alergenReaction.gif',
        },
        {
            textToDisplay: '4. In physics: \n' +
                '- Reaction to force: According to Newton\'s third law, every action has an equal and opposite reaction. This sense of the word is used in the context of physical forces.',
            imageSrc: '/images/gravityReaction.gif',
        },
        {
            textToDisplay: '5. In psychology: \n' +
                '- Behavioral or emotional response: Describes how a person responds to a situation emotionally or behaviorally, such as reacting to stress or fear.',
            imageSrc: '/images/fearReaction.gif',
        },
        {
            textToDisplay: '6. In computer science (programming): \n' +
                '- React (JavaScript library): React is a JavaScript library used to build interactive and dynamic user interfaces, especially for single-page web applications. Developed by Facebook, React allows developers to create UI components that efficiently update based on displayed data.',
            imageSrc: '/images/reactReaction.gif',
        },
        {
            textToDisplay: '7. In economics and business: \n' +
                '- Market reaction: "To react" is used to describe how financial markets, investors, or companies respond to economic, political, or regulatory changes. For example, "The market reacted positively to the interest rate cut."',
            imageSrc: '/images/marketReaction.gif',
        },
        {
            textToDisplay: '8. In politics and sociology: \n' +
                '- Social or political reaction: Represents the response of individuals, groups, or governments to events, policies, or social changes. For example, "The population reacted with protests against the new law."',
            imageSrc: '/images/politicalReaction.gif',
        },
        {
            textToDisplay: '9. In advertising and marketing: \n' +
                '- Consumer reactions: In this field, it refers to how consumers respond to a product, advertisement, or marketing campaign. For example, "Consumers reacted positively to the new product design."',
            imageSrc: '/images/productReaction.gif',
        },
        {
         textToDisplay: '10. In psychotherapy and personal development: \n' +
                '- Response to emotional stimuli: In psychotherapy, "to react" can describe how a person emotionally responds to different situations and how this response can be understood or managed.',
            imageSrc: '/images/stimulyResponse.gif',
        },
        {
            textToDisplay: '11. In simulation technology and virtual reality: \n' +
                '- Avatar or character reactions: In VR and simulations, programmed reactions of avatars or environmental elements based on user actions.',
            imageSrc: '/images/avatarReaction2.gif',
        },
        {
            textToDisplay: '12. In the military and security: \n' +
                '- Rapid reaction forces: In the military, "rapid reaction forces" are troops prepared to respond quickly in crisis situations.',
            imageSrc: '/images/militaryReaction.gif',
        },
        {
            textToDisplay: '13. In gaming: \n' +
                '- Player reactions: In video games, "to react" refers to the speed and manner in which the player responds to in-game events (e.g., "quick reactions" are essential in shooter or strategy games).',
            imageSrc: '/images/playerReaction4.webp',
        },
        {
            textToDisplay: '14. In social media: \n' +
                '- Reactions to posts: On social platforms, users can "react" to posts using reactions like like, love, angry, etc., to express their emotions towards content.',
            imageSrc: '/images/socialMediaReaction.gif',
        },
        {
            textToDisplay: '15. In emergency medicine: \n' +
                '- Reaction in emergency situations: Medical personnel or rescue teams are trained to react quickly in critical situations, such as accidents, disasters, or attacks.',
            imageSrc: '/images/medicalEmergencyReaction.gif',
        },
    ]

    },
    '4': {
        title: "React Framework Glossary",
        content: {
        reactConcepts : [
            {
                concept: "What is React?",
                description: "React is a JavaScript library for building user interfaces, particularly for single-page applications. It allows developers to build reusable UI components.",
                link: "https://reactjs.org/docs/getting-started.html"
            },
            {
                concept: "JSX (JavaScript XML)",
                description: "JSX is a syntax extension for JavaScript that looks similar to HTML. It’s used in React to describe what the UI should look like.",
                link: "https://reactjs.org/docs/jsx-in-depth.html"
            },
            {
                concept: "Components",
                description: "React applications are built using components, which are reusable building blocks for UIs. Components can be functional or class-based.",
                link: "https://reactjs.org/docs/components-and-props.html"
            },
            {
                concept: "State",
                description: "State is an object that determines the behavior of a component. It allows components to create dynamic, interactive UIs.",
                link: "https://reactjs.org/docs/state-and-lifecycle.html"
            },
            {
                concept: "Props",
                description: "Props (short for properties) are read-only inputs passed from a parent component to a child component to configure or customize the child’s output.",
                link: "https://reactjs.org/docs/components-and-props.html"
            },
            {
                concept: "Virtual DOM",
                description: "The Virtual DOM is a lightweight copy of the actual DOM. React updates the virtual DOM first, then compares it with the actual DOM to make efficient updates.",
                link: "https://reactjs.org/docs/virtual-dom.html"
            },
            {
                concept: "Hooks",
                description: "Hooks are functions that let you 'hook into' React state and lifecycle features from function components. Common hooks include useState, useEffect, and useContext.",
                link: "https://reactjs.org/docs/hooks-intro.html"
            },
            {
                concept: "useState Hook",
                description: "The useState hook is used to add state to functional components. It returns an array with the current state and a function to update it.",
                link: "https://reactjs.org/docs/hooks-state.html"
            },
            {
                concept: "useEffect Hook",
                description: "The useEffect hook allows you to perform side effects (e.g., data fetching, subscriptions) in function components. It runs after every render or when dependencies change.",
                link: "https://reactjs.org/docs/hooks-effect.html"
            },
            {
                concept: "useContext Hook",
                description: "The useContext hook allows you to access the value of a context directly without having to pass it down through the component tree.",
                link: "https://reactjs.org/docs/hooks-reference.html#usecontext"
            },
            {
                concept: "useReducer Hook",
                description: "The useReducer hook is used for managing more complex state logic. It works similarly to useState but is more powerful for handling state transitions.",
                link: "https://reactjs.org/docs/hooks-reference.html#usereducer"
            },
            {
                concept: "useRef Hook",
                description: "The useRef hook is used to persist values between renders, and it can also be used to reference DOM elements directly.",
                link: "https://reactjs.org/docs/hooks-reference.html#useref"
            },
            {
                concept: "useMemo Hook",
                description: "The useMemo hook is used to memorize a value so it’s only recalculated when its dependencies change. It helps optimize performance by avoiding unnecessary recalculations.",
                link: "https://reactjs.org/docs/hooks-reference.html#usememo"
            },
            {
                concept: "useCallback Hook",
                description: "The useCallback hook returns a memoized version of a callback function, ensuring that it only changes when its dependencies change.",
                link: "https://reactjs.org/docs/hooks-reference.html#usecallback"
            }
            ],
            advancedReactConcepts: [
                {
                    concept: "React Router",
                    description: "React Router is a library used for handling navigation within a React app. It allows you to create single-page applications with navigation between different views.",
                    link: "https://reactrouter.com/"
                },
                {
                    concept: "Redux",
                    description: "Redux is a state management library often used with React to manage the global state of an application. It’s useful for large applications with complex state logic.",
                    link: "https://redux.js.org/introduction/getting-started"
                },
                {
                    concept: "Server-Side Rendering (SSR)",
                    description: "SSR allows you to render a React application on the server, sending HTML to the client rather than JavaScript. It improves performance and SEO.",
                    link: "https://reactjs.org/docs/react-dom-server.html"
                },
                {
                    concept: "Code Splitting",
                    description: "Code splitting allows you to split your bundle into smaller files, which can be loaded as needed. This improves performance and reduces load time.",
                    link: "https://reactjs.org/docs/code-splitting.html"
                },
                {
                    concept: "Context API",
                    description: "The Context API is a way to share values like state across the component tree without having to pass props manually through each level.",
                    link: "https://reactjs.org/docs/context.html"
                },
                {
                    concept: "React Performance Optimization",
                    description: "React provides various methods and techniques for optimizing performance, including memoization with `React.memo`, lazy loading, and PureComponent.",
                    link: "https://reactjs.org/docs/optimizing-performance.html"
                },
                {
                    concept: "Error Boundaries",
                    description: "Error Boundaries are React components that catch JavaScript errors anywhere in the component tree and display a fallback UI instead of crashing the app.",
                    link: "https://reactjs.org/docs/error-boundaries.html"
                },
                {
                    concept: "React Concurrent Mode",
                    description: "React Concurrent Mode is an experimental feature that enables React to work in a way that ensures apps remain responsive and interactive, even under heavy load.",
                    link: "https://reactjs.org/blog/2020/02/26/react-concurrent-mode.html"
                },
                {
                    concept: "React Suspense",
                    description: "React Suspense allows you to wait for some asynchronous data to load before rendering parts of your component tree. It can be used with data fetching and code-splitting.",
                    link: "https://reactjs.org/docs/react-api.html#reactsuspense"
                },
                {
                    concept: "React Native",
                    description: "React Native is a framework for building mobile applications using React. It allows you to create native mobile apps for iOS and Android using JavaScript.",
                    link: "https://reactnative.dev/"
                }
            ]
        }
        },
        '5': {
            title: "Human Reactions In Culture",
            content: {


                art: [
                    {
                        name: "The Scream",
                        creator: "Edvard Munch",
                        reaction: "Anxiety, existential dread, and terror",
                        details: "Represents a figure holding its face in despair against a blood-red sky. Inspired by Munch's experience of hearing 'a scream through nature.'",
                        funFact: "Munch created four versions of 'The Scream'—two paintings and two pastels.",
                        imageSrc: "/images/TheScream.jpg"
                    },
                    {
                        name: "David",
                        creator: "Michelangelo",
                        reaction: "Confidence and determination",
                        details: "Depicts the biblical hero David before his battle with Goliath, embodying calm yet focused courage.",
                        funFact: "The statue stands 17 feet tall and was carved from a single block of marble.",
                        imageSrc: "/images/David.jpg"
                    },
                    {
                        name: "Guernica",
                        creator: "Pablo Picasso",
                        reaction: "Horror and anguish in the face of war",
                        details: "Painted in response to the bombing of Guernica during the Spanish Civil War, showing the chaos and suffering caused by violence.",
                        funFact: "Picasso refused to let 'Guernica' return to Spain until democracy was restored.",
                        imageSrc: "/images/Guernica.jpg"
                    },
                    {
                        name: "Laocoön and His Sons",
                        creator: "Ancient Greek Sculptors",
                        reaction: "Agony and struggle",
                        details: "Portrays Laocoön and his sons being attacked by sea serpents as punishment from the gods.",
                        funFact: "Discovered buried in Rome in 1506, greatly influencing Renaissance artists like Michelangelo.",
                        imageSrc: "/images/Laocoön_and_his_sons_group.jpg"
                    },
                    {
                        name: "Girl with a Pearl Earring",
                        creator: "Johannes Vermeer",
                        reaction: "Mystery and quiet allure",
                        details: "Captures a young girl in a moment of stillness, her expression open to interpretation.",
                        funFact: "The pearl earring may actually be an illusion—it looks like a smudge of paint rather than a real pearl.",
                        imageSrc: "/images/Pearl.jpg"

                    }
                ],
                literature: [
                    {
                        name: "Frankenstein",
                        creator: "Mary Shelley",
                        reaction: "Fear and guilt",
                        details: "Explores the moral consequences of playing God, as Victor Frankenstein reacts with regret and horror to the creature he creates.",
                        funFact: "Written when Shelley was just 18 years old, it’s considered the first science fiction novel.",
                        imageSrc: "/images/Frank.jpg"

                    },
                    {
                        name: "The Catcher in the Rye",
                        creator: "J.D. Salinger",
                        reaction: "Alienation and rebellion",
                        details: "Holden Caulfield reacts to the world with cynicism and a longing to protect innocence.",
                        funFact: "The novel was banned in several countries for its use of profanity and themes of teenage angst.",
                        imageSrc: "/images/Catcher.jpg"
                    },
                    {
                        name: "Oedipus Rex",
                        creator: "Sophocles",
                        reaction: "Shock and despair",
                        details: "Oedipus reacts to the realization of his fate—having unwittingly killed his father and married his mother—with devastation.",
                        funFact: "The term 'Oedipus complex' in psychology comes from this play.",
                        imageSrc: "/images/Oedipus.jpg"
                    }
                ],


                filmography: [
                    {
                        name: "Inside Out",
                        releaseYear: 2015,
                        reaction: "Joy, sadness, anger, disgust, and fear",
                        details: "Personifies emotions as characters inside a young girl’s mind, showing how reactions shape our personality.",
                        funFact: "The movie was based on psychological research about how emotions affect memory.",
                        imageSrc: "/images/InsideOut.jpg"
                    },
                    {
                        name: "Yumi’s Cells",
                        releaseYear: 2021,
                        reaction: "Internal conflict and emotional growth",
                        details: "Uses animated cells to represent Yumi’s emotions and thoughts, offering a humorous take on human reactions.",
                        funFact: "The show is based on a webtoon of the same name.",
                        imageSrc: "/images/YummyCells.jpg"
                    },
                    {
                        name: "The Pursuit of Happyness",
                        releaseYear: 2006,
                        reaction: "Perseverance and triumph",
                        details: "Based on a true story, it shows how Chris Gardner reacts to hardships with determination to create a better life for his son.",
                        funFact: "Will Smith starred in the movie alongside his real-life son, Jaden.",
                        imageSrc: "/images/ThePursiutOfHappiness.png"
                    },
                    {
                        name: "Requiem for a Dream",
                        releaseYear: 2000,
                        reaction: "Despair and addiction",
                        details: "Portrays how addiction consumes the lives of its characters, leading to catastrophic consequences.",
                        funFact: "The haunting soundtrack, 'Lux Aeterna,' became iconic and is widely used in trailers.",
                        imageSrc: "/images/Requiem.jpg"
                    }
                ],


                theatre: [
                    {
                        name: "Hamlet",
                        creator: "William Shakespeare",
                        reaction: "Indecision and existential angst",
                        details: "Hamlet’s famous 'To be or not to be' soliloquy captures his internal struggle and reaction to life’s uncertainties.",
                        imageSrc: "/images/Hamlet.jpg"
                    },
                    {
                        name: "A Streetcar Named Desire",
                        creator: "Tennessee Williams",
                        reaction: "Desperation and vulnerability",
                        details: "Blanche DuBois reacts to her downfall with increasing fragility and denial.",
                        imageSrc: "/images/Desire.webp"
                    },
                    {
                        name: "Les Misérables",
                        creator: "Victor Hugo",
                        reaction: "Resilience and redemption",
                        details: "Jean Valjean reacts to suffering with remarkable strength and a pursuit of justice.",
                        imageSrc: "/images/LM.jpg"
                    }
                ],


                symbols: [
                    {
                        name: "Japan’s Flag",
                        reaction: "Simplicity and serenity",
                        details: "The red circle represents the rising sun, a symbol of life and energy.",
                        funFact: "It’s one of the oldest national symbols in the world, dating back to the 7th century.",
                        imageSrc: "/images/Japan.webp"
                    },
                    {
                        name: "The Mirror",
                        reaction: "Reflection and self-awareness",
                        details: "Often used in art and literature to symbolize truth, vanity, or the soul.",
                        funFact: "In folklore, mirrors are believed to trap or reveal spirits.",
                        imageSrc: "/images/Oglinda.png"
                    },
                    {
                        name: "The Labyrinth",
                        reaction: "Confusion and enlightenment",
                        details: "A common motif in mythology, the labyrinth symbolizes life’s challenges and the journey to self-discovery.",
                        funFact: "The myth of Theseus and the Minotaur is the most famous labyrinth story.",
                        imageSrc: "/images/Labirintul.jpg"
                    },
                    {
                        name: "Yin and Yang",
                        reaction: "Balance and duality",
                        details: "Represents the interconnectedness of opposites, like light and dark.",
                        funFact: "The dots within each side symbolize that each force contains a seed of the other.",
                        imageSrc: "/images/YinYang.jpg",

                    }
                ]
            }

        }


}


const App = () => {
    const [selectedContent, setSelectedContent] = useState(menuContent['1']); // Default content

    const onClick = (e) => {
        setSelectedContent(menuContent[e.key] || { title: '', content: [] }); // Update title and content
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header
                style={{
                    background:'#2a1c33',
                    color:'#f8c867',
                    textAlign: 'center',
                    fontSize: '38px',
                    fontWeight: 'bold',
                    fontFamily: 'fantasy'
                }}
            >
          Expl🔎REACT
            </Header>
            <Layout>
                <Sider
                    width={256}
                    style={{
                        background:'#2a1c33',

                    }}
                >
                    <Menu
                        theme="dark"
                        className={"my_menu"}
                        onClick={onClick}
                        defaultSelectedKeys={['1']}
                        mode="inline"
                        items={items}
                        style={{ background:'#493765'}}
                    />
                </Sider>
                <Content
                    style={{
                        padding: '16px',
                        background: 'linear-gradient(to right, #432E54, #4B4376, #e4b1e1 )'
                    }}
                >
                    <DynamicCarousel title={selectedContent.title} content={selectedContent.content} />
                </Content>
            </Layout>
        </Layout>
    );
};

export default App;
